export default "__VITE_ASSET__C_wQsp46__"